import * as React from "react";
import minusIcon from "@/assets/minus-icon.png";
import plusIcon from "@/assets/plus-icon.png";
import { circularButtonStyles as styles } from "./styles";
import { TouchableOpacity } from "../../Buttons";
import { colors } from "@/app/constants/styles";
import { TposIcon } from "../../Icons/TposIcon";

type CircularButtonProps = {
  onPress: () => void;
  disabled: boolean;
  add?: boolean;
};

const CircularButton = ({
  onPress,
  disabled,
  add = false,
}: CircularButtonProps) => (
  <TouchableOpacity
    onPress={onPress}
    style={[
      styles.buttonContainer,
      { backgroundColor: disabled ? colors.transparentButton : colors.white },
    ]}
    accessibilityRole="button"
    accessibilityState={{ disabled }}
    accessibilityLabel={add ? "Increase quantity" : "Decrease quantity"}
    testID={add ? "increase-quantity-button" : "decrease-quantity-button"}
  >
    {add ? (
      <TposIcon icon={plusIcon} size={55} />
    ) : (
      <TposIcon icon={minusIcon} size={55} />
    )}
  </TouchableOpacity>
);

export default CircularButton;
